import { Recurso } from "lib.common/dist/CleanArch";
import { ErrDevValidacion } from 'lib.common/dist/errorHandler';
import { FechaParams, GetEstadoLlavesAnualParams } from "../../utils/params/EstadisticasDsKey.params";
import { EstadisticasDsKeyRepository } from "../../bussines/repository/EstadisticasDsKeyRepository";
import { EstadisticasLlaveModel } from "../models/EstadisticasLlaveModel";
import { DataLlaveModel } from "../models/DataLlaveModel";
import { EstadoLlaveAnualModel } from "../models/EstadoLlaveAnualModel";
import { ResumenLlaveByClienteProductoUsuarioModel } from "../models/ResumenLlaveByClienteProductoUsuarioModel";
import { EstadisticasDsKeyDtSource } from "../../bussines/dataSources/EstadisticasDsKeyDtSource";

export class EstadisticasDsKeyRepositoryImpl implements EstadisticasDsKeyRepository<EstadisticasLlaveModel, DataLlaveModel, EstadoLlaveAnualModel, ResumenLlaveByClienteProductoUsuarioModel> {
    private dataSource: EstadisticasDsKeyDtSource;

    constructor(dataSource: EstadisticasDsKeyDtSource) {
        this.dataSource = dataSource;
    }

    async getEstadisticasLlaves(input: FechaParams): Promise<Recurso<EstadisticasLlaveModel>> {
        try {
            const result = await this.dataSource.getEstadisticasLlaves(input);

            if (result.isSuccess()) {
                return Recurso.fromData<EstadisticasLlaveModel>(
                    EstadisticasLlaveModel.deserialize(result.data!)
                );
            }
            return Recurso.fromError<EstadisticasLlaveModel>(result.error!);
        } catch (error) {
            return Recurso.fromError<EstadisticasLlaveModel>(
                new ErrDevValidacion(error as Error)
            );
        }
    }

    async getLlavesAnuladasMes(input: FechaParams): Promise<Recurso<DataLlaveModel[]>> {
        try {
            const result = await this.dataSource.getLlavesAnuladasMes(input);

            if (result.isSuccess()) {
                return Recurso.fromData<DataLlaveModel[]>(
                    result.data!.map(DataLlaveModel.deserialize)
                );
            }
            return Recurso.fromError<DataLlaveModel[]>(result.error!);
        } catch (error) {
            return Recurso.fromError<DataLlaveModel[]>(
                new ErrDevValidacion(error as Error)
            );
        }
    }

    async getLlavesPorExpirar(): Promise<Recurso<DataLlaveModel[]>> {
        try {
            const result = await this.dataSource.getLlavesPorExpirar();

            if (result.isSuccess()) {
                return Recurso.fromData<DataLlaveModel[]>(
                    result.data!.map(DataLlaveModel.deserialize)
                );
            }
            return Recurso.fromError<DataLlaveModel[]>(result.error!);
        } catch (error) {
            return Recurso.fromError<DataLlaveModel[]>(
                new ErrDevValidacion(error as Error)
            );
        }
    }

    async getEstadoLlavesAnual(input: GetEstadoLlavesAnualParams): Promise<Recurso<EstadoLlaveAnualModel[]>> {
        try {
            const result = await this.dataSource.getEstadoLlavesAnual(input);

            if (result.isSuccess()) {
                return Recurso.fromData<EstadoLlaveAnualModel[]>(
                    result.data!.map(EstadoLlaveAnualModel.deserialize)
                );
            }
            return Recurso.fromError<EstadoLlaveAnualModel[]>(result.error!);
        } catch (error) {
            return Recurso.fromError<EstadoLlaveAnualModel[]>(
                new ErrDevValidacion(error as Error)
            );
        }
    }

    async getResumenLlaves(input: FechaParams): Promise<Recurso<ResumenLlaveByClienteProductoUsuarioModel[]>> {
        try {
            const result = await this.dataSource.getResumenLlaves(input);

            if (result.isSuccess()) {
                return Recurso.fromData<ResumenLlaveByClienteProductoUsuarioModel[]>(
                    result.data!.map(ResumenLlaveByClienteProductoUsuarioModel.deserialize)
                );
            }
            return Recurso.fromError<ResumenLlaveByClienteProductoUsuarioModel[]>(result.error!);
        } catch (error) {
            return Recurso.fromError<ResumenLlaveByClienteProductoUsuarioModel[]>(
                new ErrDevValidacion(error as Error)
            );
        }
    }
}